import {TextField} from "@material-ui/core";
import {styled} from "styled-components";

const TextFieldWithWarning = styled(TextField)<{warning: boolean}>`
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: ${({warning}) => (warning ? "orange" : "")};
    }
  }
`;

export default TextFieldWithWarning;
